import {supabase} from './supabaseClient';
import type {User} from '@/db';
export function mapCloudUser(row: any):User {
 return {id:Number(row.id),authId:row.auth_id,name:row.name,email:row.email,passwordHash:'',phone:row.phone||'',role:row.role,division:row.division||'',managerEmail:row.manager_email||'',responsibleName:row.responsible_name||'',jobTitle:row.job_title||'',productCodes:row.product_codes??undefined,active:row.active&&!row.deleted_at,forcePasswordChange:row.force_password_change,createdAt:row.created_at};
}
export async function listCloudUsers():Promise<User[]> {
 if(!supabase)throw Error('Supabase não configurado');
 const {data,error}=await supabase.from('zsb_users').select('*').order('name');
 if(error)throw Error('Não foi possível consultar os usuários.');
 return (data||[]).map(mapCloudUser);
}
export async function manageCloudUser(action:string,fields:Record<string,unknown>={}) {
 if(!supabase)throw Error('Supabase não configurado');
 if(sessionStorage.getItem('zsb_simulated_user_id'))throw Error('Encerre a simulação para modificar usuários.');
 const {data,error}=await supabase.functions.invoke('zsb-users',{body:{action,...fields}});
 if(error){let message='Não foi possível concluir a operação.';try {message=(await error.context.json()).error||message;}catch{message=error.message||message;}throw Error(message);}
 if(data?.error)throw Error(data.error);
 window.dispatchEvent(new Event('zsb-auth-change'));
 return data;
}
